module.exports = __webpack_public_path__ + "officialStatic/img/teacherBg.b14883e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/teacherBg.png
// module id = d3/7
// module chunks = 0